module.exports = __webpack_public_path__ + "static/media/check-success.56f527f5.svg";